import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import { Home as HomeIcon, LayoutGrid, Heart, ShoppingBag, User } from "lucide-react";
import { useCart } from "@/context/CartContext";
import { useWishlist } from "@/context/WishlistContext";

export default function MobileNav() {
  const { count, setOpen } = useCart();
  const { items: wish } = useWishlist();
  const loc = useLocation();
  if (loc.pathname.startsWith("/admin")) return null;

  const linkCls = ({ isActive }) =>
    `flex flex-col items-center gap-1 py-2 flex-1 text-[10px] tracking-wider uppercase ${isActive ? "text-[#D4AF37]" : "text-[#1E293B]/60"}`;

  return (
    <>
      <nav className="md:hidden fixed bottom-0 inset-x-0 z-30 bg-[#FCE4EC]/95 backdrop-blur-md border-t pb-safe" style={{ borderColor: "rgba(114,47,55,0.2)" }} data-testid="mobile-bottom-nav">
        <div className="flex items-stretch">
          <NavLink to="/" end className={linkCls} data-testid="mnav-home"><HomeIcon size={18} /> Home</NavLink>
          <NavLink to="/shop/women" className={linkCls} data-testid="mnav-shop"><LayoutGrid size={18} /> Shop</NavLink>
          <NavLink to="/wishlist" className={linkCls} data-testid="mnav-wishlist">
            <span className="relative"><Heart size={18} />
              {wish.length > 0 && <span className="absolute -top-1 -right-2 bg-[#D4AF37] text-[9px] text-[#0B1F3A] w-3.5 h-3.5 rounded-full flex items-center justify-center font-semibold">{wish.length}</span>}
            </span> Saved
          </NavLink>
          <button onClick={() => setOpen(true)} className="flex flex-col items-center gap-1 py-2 flex-1 text-[10px] tracking-wider uppercase text-[#1E293B]/60" data-testid="mnav-cart">
            <span className="relative"><ShoppingBag size={18} />
              {count > 0 && <span className="absolute -top-1 -right-2 bg-[#D4AF37] text-[9px] text-[#0B1F3A] w-3.5 h-3.5 rounded-full flex items-center justify-center font-semibold">{count}</span>}
            </span> Cart
          </button>
          <NavLink to="/login" className={linkCls} data-testid="mnav-account"><User size={18} /> Account</NavLink>
        </div>
      </nav>
      <div className="md:hidden h-16" aria-hidden />
    </>
  );
}
